export default "__VITE_ASSET__c6ddb688__"